import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,

  Tooltip,
  OverlayTrigger,
  Button
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";

import { userActions } from '../../../redux/actions/user-actions';


import UserList from "./UserList";
import UserForm from "./UserForm";
var Modal = require('react-bootstrap-modal');

class AdminUserListPage extends Component{
  constructor(props){
  	super(props);
  	this.state = {
      company_id : null,
  		submitted : false,
  		addModalUser: false,
      addModalUserEdit:false,
  		user:{ name:'', email: '', password:'', phone:'', permission:0 },
	   	userError : {
	        nameError:'',
	        emailError:'',
	        passwordError:'',
	        phoneError:''
	    },
      users : {},
  	};
    this.openModalUser = this.openModalUser.bind(this);
    this.closeModalUser = this.closeModalUser.bind(this);

  	this.openModalUserEdit = this.openModalUserEdit.bind(this);
  	this.closeModalUserEdit = this.closeModalUserEdit.bind(this);

  	this.handleUserSubmitPar = this.handleUserSubmitPar.bind(this);
  	this.handleUserEditSubmitPar = this.handleUserEditSubmitPar.bind(this);

    this.clearField = this.clearField.bind(this);

    this.deleteUser = this.deleteUser.bind(this);
  	this.deleteConfirmUser = this.deleteConfirmUser.bind(this);
  };
  openModalUser(){
    this.clearField();
    this.setState({addModalUser:true});
  }
  closeModalUser(){
    this.clearField();
    this.setState({addModalUser:false});
  }
  openModalUserEdit(id){
    this.clearField();
    const { dispatch } = this.props;
    dispatch(userActions.getUser(id));
  }
  closeModalUserEdit(){
    this.clearField();
    this.setState({addModalUserEdit:false});
  }
  handleUserSubmitPar(userData){
    const { dispatch } = this.props;
    dispatch(userActions.storeUser(userData));
  }
  handleUserEditSubmitPar(userData){
    const { dispatch } = this.props;
    dispatch(userActions.editUser(userData, this.props.editUser.id));
  }
  clearField(){
    this.setState({user:{name:'', email:'', password:'', phone:'', 'permission':0}});
    this.setState({userError:{nameError:'', emailError:'', passwordError:'', phoneError:''}});
  }
  deleteUser(userId){
    const { dispatch } = this.props;
    dispatch(userActions.deleteUser(userId));
  }
  deleteConfirmUser(userId){
  	confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Delete Admin User</h3>
              <p className="marginFromTopPopUp" >Are you sure to delete the admin user?</p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.deleteUser(userId)
                    onClose()
                }}>Yes</button>
              </div>
            </div>
            
          </div>
        )
      }
    })
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(userActions.getUsers(this.state.company_id));
  } 
  componentWillReceiveProps(nextProps) {
  	if (nextProps.editUser && !nextProps.loading){
	    this.setState({user:{
	      name:nextProps.editUser.name,
	      email:nextProps.editUser.email,
	      password:'',
	      phone: nextProps.editUser.phone,
	      permission: nextProps.editUser.permission
	    }}, function(){
	      this.setState({addModalUserEdit:true});
	    });
	 }
	 if (nextProps.users) {
		this.setState({users:nextProps.users});
	 }
  }
  render(){
  	const {  user, userError, submitted } = this.state;
  	const { editUser, users, userAdmin } = this.props;
  	return(
  		<div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                  title="Admin Users List"
                  ctTableResponsive
                  content={
                  	<div>
                    	<Grid fluid>
                        <Row>
                            <Col md={2} sm={6} xs={12}>
                              <div >
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Add Admin User</Tooltip>}>
                                  <Button type='button' className="outOfTableButton btn btn-info" onClick={this.openModalUser} ><i className="fa fa-plus" />Admin User</Button>
                                </OverlayTrigger>
                              </div>
                            </Col>
                        </Row>
                      </Grid>
                      
                      {/* Users List */}
                  		{
                        users && users.length > 0 &&
                        <UserList userProp={users} openModalUserEditProp={this.openModalUserEdit} deleteConfirmUserProp={this.deleteConfirmUser} userId={userAdmin.user.id} adminUserPro={userAdmin} componentPro="adminUser" />
                      }
                		  
                      {/* Users Not Found */}
                      {
                        users && users.length === 0 &&
                        <Grid fluid>
                          <Row>
                              <Col md={8}>
                                <h4>No Company User Found</h4>
                              </Col>
                          </Row>
                        </Grid>
                      }

                      {/*Add User Modal Start*/}
                      <Modal show={this.state.addModalUser} onHide={this.closeModalUser} aria-labelledby="ModalHeader" >
                        <Modal.Header closeButton>
                          <Modal.Title id='ModalHeader'>Add Admin User</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <UserForm closeModalUserEditPro={this.closeModalUserEdit} closeModalUserPro={this.closeModalUser} formTypePro="add"  userPro=''      userErrorPro=''          submittedPro={submitted} adminTypePro={userAdmin.type}  handleUserSubmitParPro={this.handleUserSubmitPar}  handleUserEditSubmitParPro={this.handleUserEditSubmitPar} componentPro="adminUser" />
                            </div>
                          </div>
                        </Modal.Body>
                      </Modal>
                      {/*Add User Modal End*/}

                		  {/*Edit User Modal start*/}
                      { editUser &&
                        <Modal show={this.state.addModalUserEdit} onHide={this.closeModalUserEdit} aria-labelledby="ModalHeader" >
                        <Modal.Header closeButton>
                          <Modal.Title id='ModalHeader'>Admin Edit User</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <UserForm closeModalUserEditPro={this.closeModalUserEdit} closeModalUserPro={this.closeModalUser} formTypePro="edit" userPro={user}  userErrorPro={userError} submittedPro={submitted} adminTypePro={userAdmin.type} handleUserSubmitParPro={this.handleUserSubmitPar}  handleUserEditSubmitParPro={this.handleUserEditSubmitPar} componentPro="adminUser" />
                            </div>
                          </div>
                        </Modal.Body>
                        </Modal>
                      }
                      {/*Edit User Modal End*/}
                  	</div>
                  } />
            </Col>
          </Row>
        </Grid>
      </div>
  	);
  };
}
function mapStateToProps(state) {
  const {  editUser, loading, users } = state.userReducer;
  const { userAdmin } = state.adminReducer;
  return {
      users, editUser, userAdmin, loading
  };
}
const AdminUsers = connect(mapStateToProps)(AdminUserListPage);
export default AdminUsers;


// WEBPACK FOOTER //
// ./src/components/Admin/Users/AdminUsers.jsx